import { Box, ListItem, UnorderedList } from "@chakra-ui/react";
import { TransactionCalculationAddOrSubtractEnum } from "gen/model/transactionCalculationAddOrSubtractEnum";
import React from "react";
import { isSafari } from "shared/utils/BrowserUtils";

type CalculationArithmeticList = React.FC<React.PropsWithChildren> & {
  Item: typeof Item;
};

// eslint-disable-next-line no-redeclare
export const CalculationArithmeticList: CalculationArithmeticList = ({
  children,
}) => (
  <UnorderedList
    textAlign="left"
    marginInlineStart="1ch"
    sx={{
      li: {
        my: "0px",
        paddingInlineStart: "0.5ch",
        "& > .mb-list-item-wrapper": {
          display: "inline-block",
          verticalAlign: "top",
          mt: "1px",
        },
        // using 'content' inside '::marker' is not supported in safari,
        // see: https://bugs.webkit.org/show_bug.cgi?id=204163
        ...(isSafari
          ? {
              "&.op-add div::before": {
                content: "'+ '",
              },
              "&.op-subtract div::before": {
                content: "'- '",
              },
            }
          : {
              "&::marker": {
                lineHeight: "16px",
              },
              "&.op-add::marker": {
                content: "'+'",
              },
              "&.op-subtract::marker": {
                content: "'-'",
              },
            }),
      },
    }}
  >
    {children}
  </UnorderedList>
);

const Item: React.FC<
  React.PropsWithChildren<{
    addOrSubtract: TransactionCalculationAddOrSubtractEnum;
  }>
> = ({ addOrSubtract, children }) => (
  <ListItem className={`op-${addOrSubtract}`}>
    <Box display="inline-block" verticalAlign="top" mt="1px">
      {children}
    </Box>
  </ListItem>
);

CalculationArithmeticList.Item = Item;
